import { makeStyles } from '@mui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { setViewIsDirty } from 'features/ux/uxSlice';
import { useCallback, useEffect, useRef, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

const useStyles = makeStyles(styles);

export function PromptAlert(props) {
  const classes = useStyles();
  const {
    onConfirm = () => {},
    onCancel = () => {},
    title = 'Are you sure you want to leave?',
    message = 'You have unsaved changes that will be lost if you leave this page.',
    okText = 'Confirm',
    cancelText = 'Cancel',
    showCancel = true,
  } = props;
  return (
    <SweetAlert
      warning
      title={title}
      customClass={classes.alertText}
      confirmBtnText={okText}
      showCancel={showCancel}
      cancelBtnText={cancelText}
      confirmBtnCssClass={classes.button + ' ' + classes.primary}
      cancelBtnCssClass={classes.button + ' ' + classes.secondary}
      onConfirm={() => {
        onConfirm();
      }}
      onCancel={() => {
        onCancel();
      }}
    >
      {message}
    </SweetAlert>
  );
}

export function RouterPrompt(props) {
  const classes = useStyles();
  const {
    when,
    onOK = () => true,
    onCancel = () => false,
    title = 'Are you sure you want to leave?',
    message = 'You have unsaved changes that will be lost if you leave this page.',
    okText = 'Confirm',
    cancelText = 'Cancel',
  } = props;

  const history = useHistory();
  const dispatch = useDispatch();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [currentState, setCurrentState] = useState({});
  const unblockRef = useRef();

  useEffect(() => {
    unblockRef.current = history?.block((location) => {
      if (when) {
        setCurrentPath(location.pathname);
        setCurrentState(location.state);
        setShowPrompt(true);
        return false;
      }
      return true;
    });
    return () => {
      unblockRef.current && unblockRef.current();
    };
  }, [when]);

  const handleOK = useCallback(async () => {
    if (onOK) {
      const canRoute = await Promise.resolve(onOK());
      if (canRoute && unblockRef) {
        unblockRef.current();
        history.push(currentPath, currentState);
        dispatch(setViewIsDirty(false));
      }
      setShowPrompt(false);
    }
  }, [currentPath, history, onOK]);

  const handleCancel = useCallback(async () => {
    if (onCancel) {
      const canRoute = await Promise.resolve(onCancel());
      if (canRoute) {
        unblockRef.current();
        history.push(currentPath);
      }
    }
    setShowPrompt(false);
  }, [currentPath, history, onCancel]);

  return showPrompt ? (
    <SweetAlert
      warning
      showCancel
      title={title}
      customClass={classes.alertText}
      confirmBtnText={okText}
      cancelBtnText={cancelText}
      confirmBtnCssClass={classes.button + ' ' + classes.primary}
      cancelBtnCssClass={classes.button + ' ' + classes.secondary}
      onConfirm={() => {
        handleOK();
      }}
      onCancel={() => {
        handleCancel();
      }}
    >
      {message}
    </SweetAlert>
  ) : null;
}
